import { render, staticRenderFns } from "./AdminPanelAdmins.vue?vue&type=template&id=4c6e77fb&"
import script from "./AdminPanelAdmins.vue?vue&type=script&lang=js&"
export * from "./AdminPanelAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports